import { scrollToId } from '@bob/library'
import { SyntheticEvent } from 'react'

/** Prevents the browser's default scroll when an anchor tag with a hash href is clicked
 * and uses our own scroll instead
 */
export const customHashScroll = (
  e: SyntheticEvent,
  scrollTarget: string,
  topCompensation: number
) => {
  e.preventDefault()
  const elementHref = (e.target as HTMLElement).getAttribute('href')

  if (elementHref) {
    window.location.hash = elementHref
  }

  void scrollToId(scrollTarget, topCompensation)
}
